export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHECK = 'AUTH_CHECK';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const UPDATE_USER_LOCAL_STORAGE = 'UPDATE_USER_LOCAL_STORAGE';
export const UPDATE_USER_NAME_LOCAL_STORAGE = 'UPDATE_USER_NAME_LOCAL_STORAGE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SET_IS_AUTH = 'SET_IS_AUTH';

export const DELETE_LOCAL_CART_ITEM = 'DELETE_LOCAL_CART_ITEM';
export const ADD_SWATCH_LOCAL_CART_ITEM = 'ADD_LOCAL_CART_ITEM';

export const ADD_PRODUCT_LOCAL_CART_ITEM = 'ADD_PRODUCT_LOCAL_CART_ITEM';
export const ADD_GIFT_CARD_LOCAL_CART_ITEM = 'ADD_GIFT_CARD_LOCAL_CART_ITEM';
export const UPDATE_GIFT_CARD_LOCAL_CART_ITEM =
  'UPDATE_GIFT_CARD_LOCAL_CART_ITEM';

export const RESET_LOCAL_CART_ITEM = 'RESET_LOCAL_CART_ITEM';

export const INCREASE_PRODUCT_LOCAL_CART_ITEM =
  'INCREASE_PRODUCT_LOCAL_CART_ITEM';
export const DECREASE_PRODUCT_LOCAL_CART_ITEM =
  'DECREASE_PRODUCT_LOCAL_CART_ITEM';

export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';

export const ANIMATE_ADD_TO_CART = 'ANIMATE_ADD_TO_CART';
export const ADD_PRODUCT_TO_WAITLIST = 'ADD_PRODUCT_TO_WAITLIST';
export const ADD_SHIPPING_SERVICE_ID = 'ADD_SHIPPING_SERVICE_ID';
export const REMOVE_SHIPPING_SERVICE_ID = 'REMOVE_SHIPPING_SERVICE_ID';

//Auth Reducer
export const SAVE_USER = 'SAVE_USER';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';

//Global
export const SET_OPEN_LOGIN_MODAL = 'SET_OPEN_LOGIN_MODAL';
export const SET_CUSTOMER_OVERLAY_NAV = 'SET_CUSTOMER_OVERLAY_NAV';

export const SET_OPEN_FABRIC_MODAL = 'SET_OPEN_FABRIC_MODAL';
export const SET_FABRIC_MODAL_DATA = 'SET_FABRIC_MODAL_DATA';

export const TOGGLE_GLOBAL_CART = 'TOGGLE_GLOBAL_CART';

export const HANDLE_GLOBAL_CART = 'HANDLE_GLOBAL_CART';
export const HANDLE_PHOTO_SIDEBAR = 'HANDLE_PHOTO_SIDEBAR';

//EXTEND
export const ADD_EXTEND_TO_PRODUCT = 'ADD_EXTEND_TO_PRODUCT';
export const REMOVE_EXTEND_FROM_PRODUCT = 'REMOVE_EXTEND_FROM_PRODUCT';
